import apiUrl from '../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import Loader from './../shared/loader'
import moment from 'moment'
import Pagination from './../shared/pagination'
export default {
  name: 'Daywisestockreport',
  components: {
    Pagination,
    DatePicker,
    Loader
  },
  props: [],
  data() {
    return {
      // totalRows:0,
      // currentPage: 0,
      loginstatus:'',
      warehouseflt:'',
      Email: '',
      userid: '',
      reportname: '',
      csvFieldsForXls: {},
      totalPage: 0,
      totalRows: 0,
      currentPage: 1,
      pageLimit: 10,
      listUserDetailsData: [],
      listStockReportFinalData: [],
      csvFields: [],
      // pageno: 0,
      // totalPage: 0,
      ProductID: '',
      isLoading: false,
      formattedDate: '',
      resultCount: 0,
      listClientData: [],
      listWarehouseData: [],
      ClientErr: '',
      WarehouseErr: '',
      searchFlag: false,
      showSelectWarehouse: false,
      showSelectClient: false,
      clientid: '',
      warehouseid: '',
      warehouse: '',
      client: '',
      DateError: '',
      user_type: '',
      userid: '',
      show: false,
      download: true,
      dataFilter2: '',
      isLoadingforxls: false,
      limitExeed: false,
      recordLimit: 0,
      useridflt:'',
      expecteddate:'',
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY hh:mm:ss');
    }
  },
  mounted() {
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdbyEmail = userdetail.email;
    var today = new Date();
    this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')

    this.userid = userdetail.userid;
    this.reportname = "StockReportDayWise"
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    this.getUserDetailsReportData();
    this.user_type = userdetail.utype;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.warehouse = this.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();
        // this.getWarehouseList();

        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }
    // this.getRecordLimit()

  },
  methods: {


    getClientList() {
      if (window.localStorage.getItem("clientList") !== null) {
        var clientListEncrypt = window.localStorage.getItem('clientList');
        var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
        var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
        this.listClientData = JSON.parse(plaintextclient);

      } else {
        var userToken = window.localStorage.getItem('userToken');
        var myStr = userToken.replace(/"/g, '');
        this.pageno = 0;

        this.input = ({
          warehouseid: this.warehouseid,
        });

        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
            'data': this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr,
            }
          })
          .then(result => {
            this.listClientData = result.data.data;
          }, error => {
            console.error(error);
          });
      }
    },
    // getWarehouseList() {
    //   if (window.localStorage.getItem("warehouseList") !== null) {
    //     var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
    //     var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
    //     var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
    //     this.listWarehouseData = JSON.parse(plaintextwarehouse);
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken')
    //     var myStr = userToken.replace(/"/g, '');
    //     this.pageno = 0;
    //     this.input = ({
    //       clientid: this.clientid,
    //     });

    //     axios({
    //         method: 'POST',
    //         'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //         'data': this.input,
    //         headers: {
    //           'Authorization': 'Bearer ' + myStr
    //         }
    //       })
    //       .then(result => {
    //         // console.log(result.data.data);
    //         this.listWarehouseData = result.data.data;
    //       }, error => {
    //         console.error(error)
    //       })
    //   }
    // },


    // warehouseSelected() {
    //   this.warehouseid = this.warehouse;
    //   this.pageno = this.totalPage = 0;
    //   if (this.warehouseid) {
    //     if (this.clientid) {
    //       // console.log(this.warehouse);
    //       // this.getUserDetailsReportData();
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },
    getUserDetailsReportDataSearch() {
      this.currentPage = 1;
      this.totalPage = 0;
      this.searchFlag = true;
      this.getUserDetailsReportData(2);
    },
    //to get client list
    getUserDetailsReportData(csvCheck = 0) {
    

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');


      this.isLoading = true;
      this.pageno = 0;
      this.input = ({
        // clientid: this.clientid,
        warehouseid: localStorage.getItem("selectedWarehouse"),
        loginstatus:this.loginstatus,
        userid: this.useridflt.trim(),
        email: this.Email.trim(),
        offset: (this.currentPage - 1) * 10,
        limit: 10,

      })


      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getuserlogindetails',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
            this.listUserDetailsData = result.data.data


            if (result.data.errorCode == -1 || result.data.errorCode == 1) {
              this.resultCount = 0
              this.totalRows = 0
            } else {
              this.totalRows = result.data.count
              console.log(this.totalRows);
              // this.resultCount = result.data.count
              if (this.totalRows < 10) {
                this.totalPage = 1
              } else {
                this.totalPage = Math.ceil(this.totalRows / 10)
              }
            }
          this.isLoading = false;
        }, error => {
          console.error(error)
        })
    },

    onPageChange(page) {
      this.currentPage = page;
      this.getUserDetailsReportData()
    },
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    dateFormatFRT(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    },
    //to reset search form
    resetSearchForm() {
      this.loginstatus ='';
      this.show = false;
      this.download = true;
      this.userid = '';
      this.warehouseflt ='';
      this.Email = '';
      this.pageno = 0;
      this.totalRows = 0;
      this.useridflt='';
      this.listUserDetailsData = [];
      this.searchFlag = false;
      if (this.user_type == 'warehouse_user')
        this.client = '';
      else if (this.user_type == 'client_user')
        this.warehouse = '';
      else {
        this.client = '';
        this.warehouse = '';
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/userslogindetails/userslogindetails.component.js